var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#28CD41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9258 23.1573C10.9258 22.4573 11.4924 21.8906 12.1924 21.8906C12.8841 21.8906 13.4508 22.4573 13.4508 23.1573C13.4508 23.849 12.8841 24.4156 12.1924 24.4156C11.4924 24.4156 10.9258 23.849 10.9258 23.1573ZM20.3008 23.1573C20.3008 22.4573 20.8675 21.8906 21.5675 21.8906C22.2591 21.8906 22.8258 22.4573 22.8258 23.1573C22.8258 23.849 22.2591 24.4156 21.5675 24.4156C20.8675 24.4156 20.3008 23.849 20.3008 23.1573Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.825 11.2908C23.3333 11.2908 23.6666 11.4658 24 11.8491C24.3333 12.2325 24.3916 12.7824 24.3166 13.2816L23.525 18.7483C23.375 19.7991 22.475 20.5733 21.4166 20.5733H12.325C11.2166 20.5733 10.3 19.7233 10.2083 18.6241L9.44163 9.53995L8.1833 9.32328C7.84997 9.26495 7.61663 8.93995 7.67497 8.60662C7.7333 8.26495 8.0583 8.03995 8.39997 8.08995L10.3875 8.38995C10.6708 8.44078 10.8791 8.67328 10.9041 8.95662L11.0625 10.8233C11.0875 11.0908 11.3041 11.2908 11.5708 11.2908H22.825ZM17.775 15.6233H20.0833C20.4333 15.6233 20.7083 15.34 20.7083 14.9983C20.7083 14.6483 20.4333 14.3733 20.0833 14.3733H17.775C17.425 14.3733 17.15 14.6483 17.15 14.9983C17.15 15.34 17.425 15.6233 17.775 15.6233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.1361e848e12eacd959fb0956dbbada53.svg";
export { ForwardRef as ReactComponent };